import { getConfig, isSupportSystem } from '../../../config';
import {
  getLocaleLanguage,
  getLocationSearchParam,
  getURLPathname,
  LanguageType,
  replaceURL,
  setLocaleLanguage,
  sleep,
} from '../../../lib';
import { jumpToSupportLogin } from '../../admin/lib/ioa-helper';
import { isNeedJoinStudio } from '../studio';
import { getCookieToken, removeCookieToken, setCookieToken } from './cookie';

const getTicketQuery = () => {
  return getLocationSearchParam('ticket');
};

const getToLoginParams = () => {
  const inviteKey = isNeedJoinStudio();
  const appendParams: string[] = [];
  if (inviteKey) {
    appendParams.push(`key=${inviteKey}`);
  }
  return appendParams;
};

export const getLoginToken = () => {
  return getTicketQuery() || getCookieToken();
};

// the only function that jump to login center
export function jumpToLogin() {
  if (isSupportSystem()) {
    jumpToSupportLogin();
    return;
  }

  const currentLanguage = getLocaleLanguage();
  const ingameLanguage = encodeURIComponent(
    currentLanguage || LanguageType.en_US
  );
  removeCookieToken();
  const search = [
    `backurl=${encodeURIComponent(getURLPathname())}`,
    ...getToLoginParams(),
    `ingame_language=${ingameLanguage}`,
  ];

  const url = `${getConfig().userURL}?${search.join('&')}`;
  replaceURL(url);
}

export const onToHomePage = () => {
  const currentLanguage = getLocaleLanguage();
  const ingameLanguage = encodeURIComponent(
    currentLanguage || LanguageType.en_US
  );
  const websiteURL = getConfig()?.websiteURL;
  const url = `${websiteURL}/?ingame_language=${ingameLanguage}`;
  window.open(url, '_self');
};

export const redirectRemoveSecurity = () => {
  let query = '';
  const urlParams = new URLSearchParams(window.location.search);
  const languageParam = urlParams.get('ingame_language') as LanguageType;
  const siteQuery = urlParams.get('site') || '';
  const activeTabQuery = urlParams.get('activeTab') || '';
  if (siteQuery) {
    query = `?site=${siteQuery}`;
  }
  if (activeTabQuery) {
    query += `${query.includes('?') ? '&' : '?'}activeTab=${activeTabQuery}`;
  }
  replaceURL(getURLPathname() + query);
  if (languageParam) {
    setLocaleLanguage(languageParam);
    urlParams.delete('ingame_language');
  }
};

export const intiLoginStep = async () => {
  const token = getLoginToken();
  if (!token) {
    jumpToLogin();
    return 0;
  }

  // url token set cookie
  const paramToken = getTicketQuery();
  if (paramToken) {
    setCookieToken(paramToken);
    await sleep(50);
    return 1;
  }

  // url no token or key
  return 2;
};
